import classNames from 'classnames';
import { getEnvironments, ENVIRONMENT_LABELS, type Environment } from '../../constants';
import { useEnvironment } from '../../hooks';
import styles from './EnvironmentSwitcher.module.scss';

export const EnvironmentSwitcher = () => {
  const { environment, setEnvironment, canSwitch } = useEnvironment();

  if (!canSwitch) {
    return (
      <span className={styles.single} aria-label="Environment">
        {ENVIRONMENT_LABELS[environment]}
      </span>
    );
  }

  return (
    <div className={styles.switcher} role="radiogroup" aria-label="Environment">
      {getEnvironments().map((option: Environment) => (
        <button
          key={option}
          type="button"
          role="radio"
          aria-checked={option === environment}
          className={classNames(styles.option, {
            [styles.selected]: option === environment,
            [styles.prod]: option === 'prod',
          })}
          onClick={() => setEnvironment(option)}
        >
          {ENVIRONMENT_LABELS[option]}
        </button>
      ))}
    </div>
  );
};
